import { RequireAccess } from '@/components'
import { DesignGalleryPage } from '@/managers'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/company/$companyId/settings/ad-designs')({
	component: RouteComponent,
})

function RouteComponent() {
	return (
		<RequireAccess
			role="jobillan"
			fallback={<p className="text-sm text-gray-500 p-8">You do not have permission to access this page.</p>}
		>
			<DesignGalleryPage />
		</RequireAccess>
	)
}
